<template>
	<div class="comp">
		<div class="compL">
			<div class="item bg1" :class="[curBusiness == 'rJiezhenDai' ? 'active' : '']" @click="changeCurBusiness('rJiezhenDai')">
				<div class="text">待接诊</div>
				<div class="num" style="color:#F77E04;">{{ rightWaitRegistrationParams.num }}</div>
			</div>
			<div class="item bg2" :class="[curBusiness == 'rJiezhenZhong' ? 'active' : '']"
				@click="changeCurBusiness('rJiezhenZhong')">
				<div class="text">诊疗中</div>
				<div class="num" style="color:#5E7BFA;">{{ rightInRegistrationParams.num }}</div>
			</div>
		</div>
		<div class="compR">
			<div class="line"> <img v-if="userInfo.club_card.is_valid == true" style="width: 26px;vertical-align: bottom"
					src="../../../assets/img/hyIcon.png" />
				客户：{{ userInfo._id ? userInfo.basic_info.nick_name : '--' }} |
				会员卡：{{ userInfo._id ? userInfo.card_info.card_id : '--' }} |
				成长值：{{userInfo._id ? userInfo.card_info.growth_value : '--'  }} |
				手机号：{{ userInfo._id ? userInfo.basic_info.user_mobile : '--' }} |
				余额：{{ userInfo._id ? userInfo.card_info.user_yue : '--' }} |
				紧急联系人：{{ userInfo._id ? userInfo.basic_info.urgent_user || '--' : '--' }} {{ userInfo._id ?
				userInfo.basic_info.urgent_user_mobile || '--' : '--' }}
				<!-- <div class="icon" style="background-color: #F78A1D;" @click="drawerYajinList_state=true;">押金</div> -->
				<div v-if="userInfo._id" class="icon" style="background-color: #F78A1D;" @click="drawerCouponList_state = true;">
					优惠券</div>
			</div>
			<div class="line">
				宠物：
				<span v-if="canChangeCurMember">
					<el-select v-if="curPetInfo._id" v-model="petId" @change="changePetInfo" filterable size="mini"
						style="width:100px;" placeholder="请选择">
						<el-option v-for="item in userInfo.pets_info" :key="item._id" :label="item.nick_name" :value="item._id">
						</el-option>
					</el-select>
					<span v-else>--</span>
					<img v-if="!$public.isNull(curPetInfo._id)"
						style="width:22px;height: 22px;vertical-align: middle;margin-left: 10px;cursor: pointer;"
						src="../../../assets/img/yiliaoxin/editPet.png"
						@click="drawerType = 'editPet'; drawerAddEditUserInfo_state = true;">
					<img v-if="!$public.isNull(userInfo._id)"
						style="width:22px;height: 22px;vertical-align: middle;margin-left: 10px;cursor: pointer;"
						src="../../../assets/img/yiliaoxin/addPet.png"
						@click="drawerType = 'addPet'; drawerAddEditUserInfo_state = true;">
				</span>
				<span v-else>
					<el-select v-if="curPetInfo._id" v-model="petId" @change="changePetInfo" disabled size="mini"
						style="width:100px;" placeholder="请选择">
						<el-option v-for="item in userInfo.pets_info" :key="item._id" :label="item.nick_name" :value="item._id">
						</el-option>
					</el-select>
				</span>
				档案号：{{ $public.isNull(danganNumber) ? '暂无' : danganNumber }} |
				<!-- 病历号：222 | -->
				{{ curPetInfo._id ? curPetInfo.apply_type.title : '--' }} |
				{{ curPetInfo._id ? curPetInfo.pet_sex : '--' }} |
				{{ curPetInfo._id ? curPetInfo.pet_color : '--' }} |
				{{ curPetInfo._id ? curPetInfo.category_info.name : '--' }} |
				{{ age }} |
				{{ curPetInfo.weight ? curPetInfo.weight + 'kg' : '--' }} |
				<!-- 是否绝育 -->
				<span v-if="curPetInfo.sterilization === 1">已绝育</span>
				<span v-else style="color:#F56C6C ;">未绝育</span>
				<!-- 性格 -->
				<span v-if="!$public.isNull(curPetInfo.character)"> |
					<span v-for="item in curPetInfo.character.split(',')" :key="item">{{ item }} </span>
				</span>
				<div v-if="curPetInfo._id" class="icon" style="background-color: #637EF9;"
					@click="drawerWeightList_state = true;">体重记录</div>
				<div v-if="curPetInfo._id" class="icon" style="background-color: #637EF9;"
					@click="drawerAllergyHistory_state = true;">过敏史</div>
			</div>
		</div>
		<drawerAddEditUserInfo v-if="drawerAddEditUserInfo_state" :dialog_type="drawerType" :userInfo="userInfo"
			:petInfo="curPetInfo" @submit="submit_drawerAddEditUserInfo"></drawerAddEditUserInfo>
		<!-- 押金 -->
		<div v-if="drawerYajinList_state">
			<drawerYajinList @submit="drawerYajinList_state = false;"></drawerYajinList>
		</div>
		<!-- 优惠券 -->
		<div v-if="drawerCouponList_state">
			<drawerCouponList @submit="drawerCouponList_state = false;"></drawerCouponList>
		</div>
		<!-- 体重记录 -->
		<div v-if="drawerWeightList_state">
			<drawerWeightList @submit="drawerWeightList_state = false;"></drawerWeightList>
		</div>
		<!-- 过敏史 -->
		<div v-if="drawerAllergyHistory_state">
			<drawerAllergyHistory @submit="drawerAllergyHistory_state = false;"></drawerAllergyHistory>
		</div>
	</div>
</template>
<script>
import drawerAddEditUserInfo from "../../../components/drawer/drawer_addEditPetInfo.vue"
import drawerYajinList from "./drawer/drawer_yajinList.vue"
import drawerCouponList from "./drawer/drawer_couponList.vue"
import drawerWeightList from "./drawer/drawer_weightList.vue"
import drawerAllergyHistory from "./drawer/drawer_allergy_history.vue"
export default {
	components: { drawerAddEditUserInfo, drawerYajinList, drawerCouponList, drawerWeightList, drawerAllergyHistory },
	data() {
		return {
			petId: '',
			// 添加或修改宠物
			drawerType: '',
			drawerAddEditUserInfo_state: false,
			// 押金 优惠券 体重记录 过敏史
			drawerYajinList_state: false,
			drawerCouponList_state: false,
			drawerWeightList_state: false,
			drawerAllergyHistory_state: false,
		}
	},
	computed: {
		userInfo() {
			return this.$store.state.yiliaoxin.userInfo
		},
		danganNumber() {
			return this.$store.state.yiliaoxin.danganNumber
		},
		platformParams() {
			return this.$store.state.yiliaoxin.platformParams;
		},
		rightWaitRegistrationParams() {
			return this.$store.state.yiliaoxin.rightWaitRegistrationParams;
		},
		rightInRegistrationParams() {
			return this.$store.state.yiliaoxin.rightInRegistrationParams;
		},
		curBusiness() {
			return this.$store.state.yiliaoxin.curBusiness;
		},
		curPetInfo() {
			let obj = this.$store.getters["yiliaoxin/curPetInfo"]
			return obj
		},
		age() {
			if (this.$public.isNull(this.curPetInfo.bron_date)) {
				return '--'
			} else {
				let petAgeArr = this.$public.calculatePetAge(this.curPetInfo.bron_date)
				return petAgeArr[0] + '岁' + petAgeArr[1] + '月'
			}
		},
		canChangeCurMember() {
			return this.$store.getters["yiliaoxin/canChangeCurMember"]
		},
	},
	watch: {
		userInfo() {
			if (!this.$public.isNull(this.curPetInfo)) {
				this.petId = this.curPetInfo._id
				this.$store.dispatch("yiliaoxin/get_danganNumber", this.curPetInfo._id)
			}
		},
	},
	mounted() {
		if (!this.$public.isNull(this.curPetInfo)) {
			this.petId = this.curPetInfo._id
		} else {
			this.petId = ''
		}
	},
	methods: {
		// changeNavIndex(i){
		// 	this.platformParams.navIndex = i
		// 	this.$store.commit("yiliaoxin/set_platformParams",this.platformParams)
		// 	this.$store.commit("yiliaoxin/set_curBusiness",'工作台')
		// },
		changeCurBusiness(str) {
			console.log(this.$store.state.yiliaoxin.router)
			this.$store.commit('yiliaoxin/set_curBusiness', str)
		},
		changePetInfo(id) {
			this.$store.commit("yiliaoxin/set_curPetId", id)
			this.$store.dispatch("yiliaoxin/get_danganNumber", id)
		},
		// 添加宠物
		submit_drawerAddEditUserInfo(b) {
			let petId = this.curPetInfo._id;
			this.drawerAddEditUserInfo_state = false;
			if (b === true) {
				this.$http.get('/api/Member/Single', { "id": this.userInfo._id }).then(res => {
					if (res.code == 0) {
						this.$store.commit('yiliaoxin/set_userInfo', res.data)
						if (this.drawerType === 'addPet') {
							this.$store.commit("yiliaoxin/set_curPetId", res.data.pets_info[res.data.pets_info.length - 1]._id)
							this.$store.dispatch("yiliaoxin/get_danganNumber", res.data.pets_info[res.data.pets_info.length - 1]._id)
						} else if (this.drawerType === 'editPet') {
							this.$store.commit("yiliaoxin/set_curPetId", petId)
							this.$store.dispatch("yiliaoxin/get_danganNumber", res.data.pets_info[res.data.pets_info.length - 1]._id)
						}
					}
				})
			}
		},
	}
}
</script>
<style scoped lang="scss">
.comp {
	width: 100%;
	height: 80px;
	margin-top: 12px;
	display: flex;

	.compL {
		width: 192px;
		margin-right: 16px;
		display: flex;
		justify-content: space-between;

		.item {
			width: 90px;
			height: 80px;
			background-color: #fff;
			border-radius: 12px;
			padding: 11px 18px;
			box-sizing: border-box;
			cursor: pointer;
			border: 2px solid transparent;

			&.bg1 {
				background-image: url(../../../assets/img/yiliaoxin/daijiezhen.png);
				background-position: 47px 40px;
				background-repeat: no-repeat;

				&.active {
					border-color: #F77E04;
					color: #F77E04;
				}
			}

			&.bg2 {
				background-image: url(../../../assets/img/yiliaoxin/zhenliaozhong.png);
				background-position: 47px 40px;
				background-repeat: no-repeat;

				&.active {
					border-color: #5E7BFA;
					color: #5E7BFA;
				}
			}

			.text {
				font-size: 12px;
				color: $fontColor;
				padding-top: 5px;
			}

			.num {
				font-size: 22px;
				padding-top: 12px;
			}
		}
	}

	.compR {
		width: calc(100% - 208px);
		background-color: #fff;
		padding: 0 16px;
		border-radius: 12px;
		box-sizing: border-box;

		.line {
			padding-top: 10px;
			box-sizing: border-box;
			font-size: 14px;

			.icon {
				line-height: 25px;
				padding: 0 10px;
				color: #fff;
				font-size: 14px;
				display: inline-block;
				border-radius: 4px;
				margin-left: 5px;
				cursor: pointer;
			}
		}
	}

}
</style>
